import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';
import * as Stores from '@core/redux/stores';
import { isModifierGroupDefaultSelected } from '@core/redux/stores';
import { OrderScreens } from '@features/ordering/utilties/enums/order-screens.utility';
import * as moment from 'moment-timezone';
import { RecipeType } from '@features/customization/models';
@Injectable()
export class MenuUtilityService {

  constructor() {
  }

  updateRecipeIncludedInfo(data: any) {
    const childRecipe = new Stores.ChildRecipeEntity();

    Object.assign(childRecipe, data);

    if (childRecipe && childRecipe.customizationGroups) {

      let customizationNames: Array<{ screenNumber: number, customizationName: string, type?:number }> = [];

      childRecipe.customizationGroups.forEach(cust => {
        const custNames = this.GetModifierInfo(cust);
        if (custNames && custNames.length > 0) {
          customizationNames = customizationNames.concat(custNames);
        }
      });

      if (customizationNames && customizationNames.length > 0) {

        const whatsOnIt = customizationNames.filter(r => r.screenNumber === OrderScreens.CustomizationScreen
          && r.customizationName !== '')
          .map(rep => rep.customizationName).join(', ');
        
          let modifierDisplayText = '';
          if(childRecipe.linkedRecipe) {
            modifierDisplayText =childRecipe?.customizationGroups?.map(cg => cg.modifierGroups?.find(mg => mg.linkedRecipeId == childRecipe.linkedRecipe?.id)?.displayText)?.find(r => r) ?? '';
          }

        let sideAndDrinks = childRecipe.linkedRecipe? 
                              (modifierDisplayText ?  modifierDisplayText + ', ': '') + childRecipe.linkedRecipe.whatsOnIt + ', ' + customizationNames.filter(r => r.screenNumber === OrderScreens.SideAndDrinkScreen && r.type == Stores.CustomizationGroupType.Side && r.customizationName !== '').map(rep => rep.customizationName).join(', ')
                             :  customizationNames.filter(r => r.screenNumber === OrderScreens.SideAndDrinkScreen
          && r.customizationName !== '')
          .map(rep => rep.customizationName).join(', ');

        childRecipe.whatsOnIt = whatsOnIt;

        if (!sideAndDrinks) {
          sideAndDrinks = childRecipe.includesDescription ?? childRecipe.comesWithText;
        }
        childRecipe.mealIncludes = sideAndDrinks;
      }
      if (childRecipe.ingredients !== null) {
        childRecipe.ingredients.forEach(foodItem => {
          if (foodItem.isProminent) {
            const ingredientDetails = childRecipe.ingredientsList.find(ingredient => ingredient.id === foodItem.ingredientId);
            if (ingredientDetails !== null) {
              if (childRecipe.whatsOnIt) {
                childRecipe.whatsOnIt += ', ' + ingredientDetails.name;
              } else {
                childRecipe.whatsOnIt += ingredientDetails.name;
              }
            }
          }
        });
      }
    }

    return childRecipe;
  }

  public GetModifierInfo(custGroup: Stores.CustomizationGroupsEntity) {

    const customizationNames: Array<{ screenNumber: number, customizationName: string, type?: number }> = [];

    if (custGroup && custGroup.modifierGroups) {
      const selectedModifierGroups = custGroup.modifierGroups
        .filter(modGrp => modGrp.isSelected === true);

      if (selectedModifierGroups && selectedModifierGroups.length > 0) {

        selectedModifierGroups.forEach(selectedModifierGroup => {
          let customizationName = '';
          let screenNumber = 1;
          const selectedModifier = selectedModifierGroup.selectedModifier ? selectedModifierGroup.modifiers
            .find(mod => mod.id === selectedModifierGroup.selectedModifier) :
            selectedModifierGroup.modifiers ? (selectedModifierGroup.modifiers.some(m => m.isSelected) ? selectedModifierGroup.modifiers.find(m => m.isSelected) : selectedModifierGroup.modifiers[0])  : undefined;

          if (selectedModifier) {
            const custGroupName = custGroup.displayText ? custGroup.displayText : custGroup.name;
            const modifierGroupName = selectedModifierGroup.displayText ? selectedModifierGroup.displayText
              : selectedModifierGroup.name;
            const modifierName = selectedModifier.summaryDescription ? selectedModifier.summaryDescription : (selectedModifier.displayText ? selectedModifier.displayText : selectedModifier.name);
            const specialInstructions = selectedModifierGroup.specialInstructionId ?
              (selectedModifier.specialInstructions ? selectedModifier.specialInstructions : [])
                .filter(sp => selectedModifierGroup.specialInstructionId.some(spids => spids === sp.id)) : '';

            if (custGroupName.toUpperCase().includes('BREAD')
              && modifierGroupName.toUpperCase().includes('BREAD')) {
              customizationName = modifierName;
              if (specialInstructions && specialInstructions.length > 0) {
                const spcialNames = specialInstructions.map(sp => sp.displayText ? sp.displayText : sp.name);
                customizationName += ' (' + spcialNames.join(', ') + ')';
              }
            } else {
              customizationName = (modifierGroupName === modifierName) ? modifierGroupName
                : (selectedModifier.summaryDescription ? selectedModifier.summaryDescription : modifierGroupName + ' (' + modifierName + ')');
            }

            screenNumber = custGroup.screenNumber;
          }
          const type = custGroup.type;
          customizationNames.push({ screenNumber, customizationName, type });
        });
      }
    }

    return customizationNames;
  }
  // Calorie Calculation Method
  calculateCalories(ingrdedient) {
    ingrdedient.nutritionInfo.Calories = this.RoundCalories(ingrdedient.Calories);
    const multiplier = ingrdedient.multiplier ? ingrdedient.multiplier : 1;
    if (ingrdedient.nutritionInfo && ingrdedient.nutritionInfo.calories) {
      return Math.round(ingrdedient.nutritionInfo.calories * multiplier);
    } else {
      return 0;
    }
  }

  checkEffectiveTime(effective: string, expiry: string) {
    expiry = '2019-08-08T23:00:00';
    const currentDate = new Date();
    return moment(currentDate).isBetween(effective, expiry, 'hour');

  }

  checkEffectiveDate(effective: string, expiry: string) {
    expiry = '2019-08-08T23:00:00';
    const currentDate = new Date();
    return moment(currentDate).isBetween(effective, expiry);

  }
  // Round Calories Method
  RoundCalories(calories: number) {
    if ((calories < 5)) {
      return 0;
    } else if ((calories < 50)) {
      return this.RoundTo(calories, 5);
    } else {
      return this.RoundTo(calories, 10);
    }
  }

  RoundFat(val: number) {
    let fat: number = val * 10;
    if (val < 0.5) {
      fat = 0;
    } else if (val < 5) {
      fat = this.RoundTo(fat, 5);
    } else {
      fat = this.RoundTo(fat, 10);
    }
    return fat / 10;
  }

  RoundSodium(Sodium: number) {
    if (Sodium < 5) {
      return 0;
    } else if (Sodium <= 140) {
      return this.RoundTo(Sodium, 5);
    } else {
      return this.RoundTo(Sodium, 10);
    }
  }

  RoundCholesterol(Cholesterol: number) {
    if (Cholesterol < 2) {
      return 0;
    } else if (Cholesterol <= 5) {
      return 5;
    } else {
      return this.RoundTo(Cholesterol, 5);
    }
  }

  RoundTo(calories: number, roundTo: number): number {
    const number: number = (<number>(Math.round(calories)));
    return (number % roundTo < (roundTo / 2)) ? number - number % roundTo : number - (number % roundTo) + roundTo;
  }

  public getScreenReadableText(text: string) : string {
    const regex = new RegExp(Object.keys(MenuUtilityService.ScreenReaderTextMap).map(key => key.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&')).join('|'),"gi");

    const screenText = text ? text?.replace(/[^\x00-\x7F]/g, "")?.replace(regex, matched => 
                              MenuUtilityService.ScreenReaderTextMap[matched.toLowerCase()]) : '';
    return screenText;                              
  }
  private static ScreenReaderTextMap = {
    '&':"and",
    '11pm-11am':"11 pm to 11 am" ,
    ' jr': ' Junior',
    ' pcs': ' pieces',
    ' w/ ':' with ',
    'jr. ': 'Junior',
    'bbq ': 'Barbeque ',
    'dr ': 'Doctor ',
    '"': 'inches',
    'extra items add $': 'adding items costs extra',
    'add $': 'adding items costs extra'
  };
  getCustomizations(childrec: Stores.ChildRecipeEntity) {
    const groupList = [];
    childrec.customizationGroups.forEach(ele => {
      const modifierGroups = ele.modifierGroups;
      if (modifierGroups !== undefined) {
        modifierGroups.forEach(modgroups => {
          if (modgroups.isSelected) {
            const customization = new Stores.Customizations();
            customization.customizationGroupId = ele.id;
            customization.modifierGroupId = modgroups.id;
            customization.modifierId = modgroups.selectedModifier;
            customization.imageUrl = modgroups.modifiers
              ?.find(modifier => modifier.id === modgroups.selectedModifier)?.imageUrl ?? modgroups.imageUrl;
            if (modgroups.linkedRecipeId) {
              customization.linkedRecipeId = modgroups.linkedRecipeId;
            }
            if (modgroups.specialInstructionId) {
              const specialInstructions = modgroups.specialInstructionId;
              customization.specialInstructionIds = specialInstructions;
            }
            groupList.push(customization);
          }
        });
      }
    });
    return groupList;
  }
  public hasSideAndDrink(recipe: Stores.ChildRecipeEntity) {
    if (recipe.includesDescription && recipe.recipeTypeId == RecipeType.AlaCarte) {
      // TODO: find a better way to do this. Using this condition to avoid regressions for the Jan 2024 release
       return (recipe.customizationGroups.some(cg => cg.modifierGroups.some(mg => !isModifierGroupDefaultSelected(mg, cg) && mg.isSelected) 
          && (cg.type == Stores.CustomizationGroupType.Side || cg.type == Stores.CustomizationGroupType.Drink)));        
    } else {
      return recipe?.customizationGroups?.some(c => c.screenNumber > 1) ?? false;
    }
  }
}
